// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3TzP3","options":"AnswerScale_options__24HiC","selected":"AnswerScale_selected__O1vqT"};